export default {
  WrapComponent: 'div',
  transitionName: 'am-slide-up',
  maskTransitionName: 'am-fade',
};



/** WEBPACK FOOTER **
 ** ./components/picker/popupProps.web.tsx
 **/